import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {FieldConfig} from '../dynamic-field/field.config';
import {FieldErrorNotifacation} from '../validation/field-notification';

@Injectable()
export class EventDispatcherService {

    public onControlClick = new Subject();
    public onControlPrefixClick = new Subject<FieldConfig<any>>();
    public onControlSuffixClick = new Subject<FieldConfig<any>>();
    public onFieldStatusChanged = new Subject();
    public onFieldValueChanged = new Subject();
    public onFieldError = new Subject();
    public onFormTouched = new Subject();
    public onSubmit = new Subject();
    public onFilesAdded = new Subject();
    public onFileDeleted = new Subject();
    public onControlBlur = new Subject();
    public notifyControlClick(config) {
        this.onControlClick.next(config);
    }

    public notifyControlPrefixClick(config) {
        this.onControlPrefixClick.next(config);
    }

    public notifyControlSuffixClick(config) {
        this.onControlSuffixClick.next(config);
    }

    public notifyFieldStatusChanged(value) {
        this.onFieldStatusChanged.next(value);
    }

    public notifyFieldValueChanged(value) {
        this.onFieldValueChanged.next(value);
    }

    public notifyFieldError(value: FieldErrorNotifacation) {
        this.onFieldError.next(value);
    }

    public notifyFormTouched() {
        //MIG13: .next()
        this.onFormTouched.next(null);
    }

    public notifySubmit() {
        //MIG13: .next()
        this.onSubmit.next(null);
    }

    public notifyFilesAdded(files: File[]) {
        this.onFilesAdded.next(files);
    }

    public notifyFileDelete(file: File) {
        this.onFileDeleted.next(file);
    }

    public notifyControlBlur(config) {
        this.onControlBlur.next(config);
    }
}
